import { Button, Table, Form, Select, Input } from "antd";
import type { ColumnsType } from "antd/es/table";
import React from "react";
import { useNavigate } from "react-router-dom";

interface DataType {
  key: string;
  title: string;
  identifier: string;
  status: string;
  priority: string;
}

const data: DataType[] = [
  {
    key: "1",
    title: "John Brown",
    identifier: "John Brown",
    status: "Active",
    priority: "medium"
  },
];

const TicketTable: React.FC = () => {
  const navigate = useNavigate();
  const { Option } = Select;

  const columns: ColumnsType<DataType> = [
    {
      title: "TITLE",
      dataIndex: "title",
      key: "title",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "IDENTIFIER",
      dataIndex: "identifier",
      key: "identifier",
    },
    {
      title: "PRIORITY",
      key: "priority",
      dataIndex: "priority",
      render: (text) => <a>{text}</a>,
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button onClick={() => navigate(`/users/${record.key}`)}>
          View
        </Button>
      ),
    },
  ];

  const onFinish = (values: any) => {
    console.log('Received values from form: ', values);
  };

  const onTextChange = () => {

  }

  const sortBy = () => {

  }


  return (<>
        <Form
          name="customized_form_controls"
          layout="inline"
          onFinish={onFinish}
          className="flex justify-between"
        >
            <Form.Item name="price" label="Search">
              <Input
                type="text"
                value={""}
                onChange={onTextChange}
                className="w-[45rem]"
              />
            </Form.Item>

            <Form.Item className="space-x-4 flex items-center" label="By">
              <Select
                value={""}
                style={{ width: 100, margin: '0 8px' }}
                onChange={sortBy}
              >
                <Option value="name">Name</Option>
                <Option value="email">Email</Option>
              </Select>
        </Form.Item>
      </Form>

      <div className="mt-8">
          <Table columns={columns} dataSource={data} />
      </div>
  </>);
};

export default TicketTable;
